import React from "react"
import { Card, CardBody, Col, Input } from "reactstrap"
import moment from "moment"

const VerifyScreensLayout = ({
  data,
  onClick,
  groupimage,
  HoursReportPage,
}) => {
  return (
    <>
      {(data || []).map((screens, key) => (
        <Col xl="2" sm="4" key={"_col_" + key}>
          <Card>
            <CardBody>
              <div
                className="product-img position-relative d-flex"
                style={{ boxShadow: !groupimage ? "0px 5px 15px grey" : "0px" }}
              >
                <img
                  src={screens.imagePath}
                  onClick={() => {
                    onClick(screens?.id, "image")
                  }}
                  className={
                    screens?.exclude !== undefined && screens?.exclude
                      ? "img-fluid mx-auto d-block selected-image-overlay"
                      : "img-fluid mx-auto d-block"
                  }
                  style={{ borderRadius: "5px" }}
                />
              </div>
              {!HoursReportPage && (
                <Input
                  type="checkbox"
                  checked={screens?.exclude !== undefined && screens?.exclude}
                  className="selected custom-checkbox-cross"
                  id={"Hide"}
                  onClick={() => onClick(screens?.id, "checkbox")}
                  style={{
                    borderRadius: "50%",
                    position: "absolute",
                    right: "10px",
                    top: "56%",
                    cursor: "pointer",
                    border: "2px solid #e69138",
                  }}
                />
              )}

              <div className="mt-2 text-center">
                {moment(new Date(screens.capturetime)).format("HH:mm:ss")}
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  )
}

export default VerifyScreensLayout
